<script>
  export let icon;
  export let label;
  export let ammo;
  export let onClick = () => {};
  export let onDecrement = () => {};
  export let onMegaDecrement = () => {};
  export let onIncrement = () => {};
  export let onMegaIncrement = () => {};
  export let onIncrementHover = () => {};
  let onIncrementMouseLeave = () => {};
  export let onDecrementHover = () => {};
  let onDecrementMouseLeave = () => {};
</script>

<div class="inventory-item" on:click={onClick}>
  <div class="icon-container">
    <img class="inventory-icon" src={icon} alt="Icon of item"/>
  </div>
  <div class="inventory-label">{label}</div>
</div>

{#if ammo !== undefined}
  <div class="inventory-ammo">
    <button class="decrement" on:click={onDecrement} on:contextmenu={onMegaDecrement} on:mouseenter={() => { onDecrementMouseLeave = onDecrementHover() || onDecrementMouseLeave;}} on:mouseleave={onDecrementMouseLeave}>
      <svg width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 2L3 14.2553L15 26" stroke="#FDFDFD" stroke-width="3"/>
      </svg>
    </button>
    <div class="ammo-count">
      {ammo}
    </div>
    <button class="increment" on:click={onIncrement} on:contextmenu={onMegaIncrement} on:mouseenter={() => { onIncrementMouseLeave = onIncrementHover() || onIncrementMouseLeave;}} on:mouseleave={onIncrementMouseLeave}>
      <svg width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 26L14 13.7447L2 2" stroke="#FDFDFD" stroke-width="3"/>
      </svg>
    </button>
  </div>
{/if}

<style>
  .inventory-label {
    align-self: center;
  }

  .inventory-item {
    display: grid;
    justify-content: center;
    align-items: flex-end;
    text-align: center;
    grid-template-columns: 100%;
  }

  .inventory-icon {
    max-height: 50px;
    max-width: 150px;
  }

  .inventory-ammo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
  }

  button {
    width: 100px;
    height: 100%;
  }
</style>